import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7c71e45e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=7c71e45e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c71e45e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c71e45e')) {
      api.createRecord('7c71e45e', component.options)
    } else {
      api.reload('7c71e45e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7c71e45e&scoped=true&", function () {
      api.rerender('7c71e45e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/config/switchConfig/index.vue"
export default component.exports